module.exports = function (c, d, f) {
  var g = {
    _html: {
      settings: {
        input: {
          generic: function (h) {
            return (
              "<input type='" +
              h.type +
              "' name='" +
              h.type +
              "' id='slid_" +
              h.key +
              "' class='inputGrey2' placeholder='" +
              h.placeholder +
              "'\n                     value='" +
              h.val +
              "' oninput='setSetting(\"" +
              h.key +
              "\", this.value)'/>"
            );
          },
          color: function (h) {
            return (
              "<input type='color' name='color' id='slid_" +
              h.key +
              "' style='float:right' value='" +
              h.val +
              "'\n                     oninput='setSetting(\"" +
              h.key +
              "\", this.value)'/>"
            );
          },
          switch: function (h) {
            return (
              "<label class='switch' style='margin-left:10px'><input type='checkbox' onclick='setSetting(\"" +
              h.key +
              "\", this.checked)'\n                     " +
              (h.val ? "checked" : "") +
              "><span class='slider'></span></label>"
            );
          },
          slider: function (h) {
            return (
              "<input type='number' class='sliderVal' id='slid_input_" +
              h.key +
              "' min='" +
              h.min +
              "' max='" +
              h.max +
              "'\n                     value='" +
              h.val +
              "' onkeypress='return delayExecute(\"" +
              h.key +
              '", this, ' +
              h.delay +
              ")' style='margin-right:0px;border-width:0px'/>\n                     <div class='slidecontainer' style='" +
              (h.style || "") +
              "'><input type='range' id='slid_" +
              h.key +
              "' min='" +
              h.min +
              "' max='" +
              h.max +
              "' step='" +
              h.step +
              "'\n                     value='" +
              h.val +
              "' class='sliderM' oninput='setSetting(\"" +
              h.key +
              "\", this.value)'></div>"
            );
          },
          select: function (h, j) {
            return (
              "<select onchange='setSetting(\"" +
              h.key +
              "\", this.value)' class='inputGrey2'>\n                     " +
              Object.keys(j).map(
                (k) =>
                  "<option value='" +
                  k +
                  "' " +
                  (k == h.val ? "selected" : "") +
                  ">" +
                  j[k] +
                  "</option>",
              ) +
              "</select>"
            );
          },
        },
      },
    },
    endScreen: {
      tabs: {
        leaderboard: {
          name: "Leaderboard",
          gen: function () {
            setTimeout(this.showTable);
            return '<table id="endTable"></table>';
          },
        },
        performance: {
          name: "Performance",
          mode: {
            ids: ["ffa", "tdm", "ctf", "kc", "point"],
            getIcon: function () {
              if (this.ids.includes(c.mode.id)) {
                return (
                  '<img src="img/modes/' + c.mode.id + '.png" class="modeIcon">'
                );
              } else {
                return '<div class="unknownModeIcon">?</div>';
              }
            },
          },
          xp: {
            animTime: 1000,
            newScoreCol: "#fff",
            getNewScoreProg: function (h, j) {
              let k = h.level > 1 ? Math.pow(h.level / f.rankVar, 2) : 0;
              return (
                (j / parseInt(Math.pow((h.level + 1) / f.rankVar, 2) - k)) * 100
              );
            },
            animateXPBar: function (h, j) {
              let k = document.getElementsByClassName("xpEndBarB")[j];
              if (k) {
                k.style.width = h + "%";
              }
            },
          },
          gen: function () {
            let {
              rank: h,
              score: j,
              kills: k,
              deaths: m,
              funds: p,
              victory: q,
            } = this.stats;
            let u = (
              this.account
                ? this.account.wins / this.account.games
                : q == -1
                  ? 0
                  : q
                    ? 1
                    : 0
            ).toFixed(2);
            let v =
              "<div id='endLayout'><div><div id='gameFundsLayout'><div class='gfSection'>" +
              ('<div class="endTitle" style="text-align:center">' +
                c.mode.name +
                '</div>\n                     <div id="modeLayout">' +
                this.mode.getIcon() +
                '\n                     <div class="modeStatus" style="' +
                (q == -1
                  ? "color:var(--yellow)"
                  : q
                    ? ""
                    : "color:var(--red)") +
                '">\n                     ' +
                (q == -1 ? "DRAW" : q ? "VICTORY" : "DEFEAT") +
                "</div></div>") +
              "</div><div class='gfSection'>" +
              ('<div id="fundsLayout" style="' +
                (c.mode.ranked ? "zoom:0.8" : "") +
                '">\n                     <div class="fundsVal">' +
                (p == "NONE" ? "NONE" : p) +
                "</div></div>") +
              "</div></div></div><div class='endSection'><div class='endTitle'>Combat Record</div><div id='combatRecordLayout'><div class='crStat'><div class='crLabel'>Score</div><div class='crVal'>" +
              j +
              "</div></div><div id='kdLayout'><div class='crStat'><div class='crLabel'>Kills</div><div class='crVal'>" +
              k +
              "</div></div><div class='crStat'><div class='crLabel'>Deaths</div><div class='crVal'>" +
              m +
              "</div></div></div><div class='crStat'><div class='crLabel'>Rank</div><div class='crVal'>" +
              h +
              "</div></div><div class='crStat'><div class='crLabel'>SPK</div><div class='crVal'>" +
              (j / (k || 1) || 0).toFixed(2) +
              "</div></div><div class='crStat'><div class='crLabel'>KDR</div><div class='crVal'>" +
              (k / (m || 1) || 0).toFixed(2) +
              "</div></div><div class='crStat'><div class='crLabel'>W/L</div><div class='crVal'>" +
              u +
              "</div></div></div></div></div>";
            if (this.account) {
              this.account.updateLevel();
              let w = this.xp.getNewScoreProg(this.account, j);
              let x = w + this.account.levelProg;
              let y = x > 100;
              v +=
                '<div class="endSection" style="margin-top:10px">' +
                ("<div id='lvlLayout'><img src='./img/levels/" +
                  d.levelIconId(this.account.level) +
                  ".png' class='xpRnk'><div class='xpLvl'>" +
                  this.account.level +
                  "</div><div class='xpEndBar'><div class='xpEndBarB' style='width: 0%;" +
                  (y ? "background-color:" + this.xp.newScoreCol : "") +
                  "'></div><div class='xpEndBarB' style='width: 0%;background-color: " +
                  this.xp.newScoreCol +
                  ";margin-left: -7px;'></div><span class='xpEndBarV blackShad'>" +
                  d.xpBarText(this.account) +
                  "</span></div><img src='./img/levels/" +
                  d.levelIconId(this.account.level) +
                  ".png' class='xpRnk' style='margin-left: auto'><div class='xpLvl'>" +
                  (this.account.level + 1) +
                  "</div></div>") +
                "</div>";
              setTimeout(() => {
                this.xp.animateXPBar(y ? x % 100 : this.account.levelProg, 0);
              });
              if (!y) {
                setTimeout(() => {
                  this.xp.animateXPBar(w, 1);
                }, this.xp.animTime);
              }
            }
            return v;
          },
        },
        clanwar: {
          name: "Clan Wars",
          gen: function () {
            var h = "";
            if (this.isCustom) {
              h +=
                "<div style='text-align:center;color:#fff;font-size:30px;background-color:rgba(0, 0, 0, 0.4);border-radius:6px;padding:20px;'>Disabled in Custom matches</div>";
            } else if (this.data && this.account) {
              if (this.account.clan) {
                if (this.account.clanCon) {
                  if (
                    this.data &&
                    (this.account.clanCon == 3 ||
                      this.data[2] >= f.clanWarLives)
                  ) {
                    h +=
                      "<div style='text-align:center;background-color:rgba(0, 0, 0, 0.4);border-radius:6px;padding:20px;'><img src='img/chals/icon_19.png' id='kiaIcon'><div style='color:var(--red);font-size:30px'>KILLED IN ACTION</div><div style='color:rgba(255, 255, 255, 0.5);font-size:20px'>Better luck next time</div></div>";
                  } else if (this.data && this.account.clanCon == 2) {
                    h +=
                      "<div style='text-align:center;color:#fff;font-size:30px;background-color:rgba(0, 0, 0, 0.4);border-radius:6px;padding:20px;'>Contract cancelled till next Clanwar</div>";
                  } else if (this.data && this.account.clanCon == 1) {
                    let j = f.clanWarLives - this.data[2];
                    let k = f.clanRegions[this.account.clanRegion - 1];
                    h +=
                      "<div id='clanwarsLayout'><div class='clanwarsSection'><div class='clanwarsTitle'>Region<div class='clanwarsSubTitle' onclick='openURL(&quot;/social.html?p=clanwars&quot;)'>World Map</div></div><div id='cwRegionOcean'><div id='cwRegionMap' style='background-size:" +
                      k.endSize +
                      "px;background-position:" +
                      k.endPos[0] +
                      "px " +
                      k.endPos[1] +
                      "px'></div><div id='cwRegionPoint'></div><div id='cwRegionArrow'><div><i class='material-icons' style='color:white;font-size:30px;transform:translateY(-4px)'>tour</i></div></div></div><div id='cwRegionText'>" +
                      k.name +
                      "</div></div><div class='clanwarsSection'><div class='clanwarsTitle'>Summary</div><div id='cwSumHolder'><div class='cwSumStat'><div class='cwSumIcon' style='background-image: url(../img/kill.svg)'></div><div class='cwSumLabel'>Total Kills</div><div class='cwSumVal' style='display: inline-block;'>" +
                      this.data[0] +
                      " <div class='cwSumVal' style='display: inline-block;color: #FBC02D;'>+" +
                      this.data[1] +
                      "</div></div></div><div class='cwSumStat'><div class='cwSumIcon'><i class='material-icons'>favorite</i></div><div class='cwSumLabel'>Lives Remaining</div><div class='cwSumVal'>" +
                      (j + this.data[3]) +
                      " <div class='cwSumVal' style='display: inline-block;color: #eb5656;'>-" +
                      this.data[3] +
                      "</div></div></div></div></div></div>";
                  } else if (this.data && !this.account.clanCon) {
                    h +=
                      "<div style='text-align:center;color:#fff;font-size:30px;background-color:rgba(0, 0, 0, 0.4);border-radius:6px;padding:20px;'>No active contract</div>";
                  }
                } else {
                  h +=
                    "<div style='text-align:center;color:#fff;font-size:30px;background-color:rgba(0, 0, 0, 0.4);border-radius:6px;padding:20px;'>Contract Required to Participate in Clan Wars</div>";
                }
              } else {
                h +=
                  "<div style='text-align:center;color:#fff;font-size:30px;background-color:rgba(0, 0, 0, 0.4);border-radius:6px;padding:20px;'>Join a Clan to Participate in Clan Wars</div>";
              }
            } else {
              h +=
                "<div style='text-align:center;color:#fff;font-size:30px;background-color:rgba(0, 0, 0, 0.4);border-radius:6px;padding:20px;'>Login to view Clan Wars</div>";
            }
            return h;
          },
        },
        medals: {
          name: "Medals",
          gen: function () {
            return '<div style="text-align:center;color:#fff;font-size:30px;background-color:rgba(0, 0, 0, 0.4);\n                     border-radius:6px;padding:20px;">Coming Soon!</div>';
          },
        },
      },
      init: function (h, j, k, l, m, o) {
        this.spectating = j;
        this.tabs.leaderboard.showTable = o;
        this.tabs.performance.account = h;
        this.tabs.performance.stats = k;
        this.tabs.clanwar.isCustom = m;
        this.tabs.clanwar.data = l;
        this.tabs.clanwar.account = h;
        this.changeTab("leaderboard");
      },
      changeTab: function (h) {
        this.currentTab = h;
        this.show();
      },
      show: function () {
        let h = "";
        if (!this.spectating) {
          h += "<div id='tabHolder'>";
          for (let k in this.tabs) {
            h +=
              '<div class="tabHeader ' +
              (k == this.currentTab ? "selected" : "") +
              '"\n                  onmouseenter="playTick()" onclick="GUI.endScreen.changeTab(\'' +
              k +
              "')\">" +
              this.tabs[k].name +
              "</div>";
          }
          h += "</div>";
        }
        let j =
          '<div class="endCard">' +
          h +
          '\n               <div class="tabBody">' +
          this.tabs[this.currentTab].gen() +
          "</div></div>";
        endTabbedView.innerHTML = j;
      },
    },
  };
  window.GUI = d.removePrivateKeys(g);
  return g;
};
